module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/02-3b0f0f00d2a12360e0d1496726f00aa8.jpg";